import { Skeleton, chakra } from '@chakra-ui/react';
import React from 'react';

import useTimeAgoIncrement from 'lib/hooks/useTimeAgoIncrement';

interface Props {
  ts: string;
  isEnabled?: boolean;
  isLoading?: boolean;
  className?: string;
  fontWeight?: number;
}

const BlockTimestamp = ({ ts, isEnabled, isLoading, className, fontWeight = 400 }: Props) => {
  const timeAgo = useTimeAgoIncrement(ts, isEnabled);

  return (
    <Skeleton isLoaded={ !isLoading } fontWeight={ fontWeight } className={ className } display="inline-block">
      <span>{ timeAgo }</span>
    </Skeleton>
  );
};

export default React.memo(chakra(BlockTimestamp));
